import React from 'react';
import { Link } from 'react-router-dom';
import Brand from './components/Brand';
import ThemeToggle from './components/ThemeToggle';

function CookiePolicy() {
  return (
    <div className="min-h-screen bg-surface text-content">
      {/* Simple Navigation */}
      <nav className="bg-surface-2 border-b border-line sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-[72px]">
            <Brand />
            <div className="flex items-center gap-4">
              <Link to="/" className="text-content-2 hover:text-accent transition">
                ← Back to Home
              </Link>
              <ThemeToggle />
            </div>
          </div>
        </div>
      </nav>

      {/* Cookie Policy Content */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-content mb-4">Cookie Policy</h1>
            <p className="text-xl text-content-2">Minimal cookies, maximum privacy</p>
          </div>
          
          <div className="bg-surface-2 rounded-2xl p-8 border border-line">
            <div className="space-y-6 text-content-2">
              <div>
                <h2 className="text-2xl font-bold text-content mb-4">Our Cookie Philosophy</h2>
                <p className="text-lg font-semibold text-accent mb-4">
                  We use cookies minimally and only for essential purposes.
                </p>
                <p>
                  At Databurst Technologies LLC, we respect your privacy and limit our use of cookies to only what's
                  necessary to provide you with the best experience and understand how to improve our services.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-content mb-4">What Are Cookies?</h2>
                <p>
                  Cookies are small text files stored on your device when you visit a website. They help 
                  websites remember your preferences and understand how you use the site.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-content mb-4">Cookies We Use</h2>
                
                <div className="space-y-4">
                  <div className="bg-surface-3 p-4 rounded-lg border border-line">
                    <h3 className="text-lg font-semibold text-content mb-2">1. Essential Cookies</h3>
                    <p className="mb-2">These are required for the website to function properly.</p>
                    <ul className="list-disc list-inside space-y-1 ml-4 text-sm">
                      <li>Session cookies (deleted when you close your browser)</li>
                      <li>Security cookies for form submissions</li>
                    </ul>
                  </div>

                  <div className="bg-surface-3 p-4 rounded-lg border border-line">
                    <h3 className="text-lg font-semibold text-content mb-2">2. Analytics Cookies (Google Analytics)</h3>
                    <p className="mb-2">We use Google Analytics to understand how visitors use our site.</p>
                    <ul className="list-disc list-inside space-y-1 ml-4 text-sm">
                      <li>Pages visited and time spent</li>
                      <li>General location (country/city level only)</li>
                      <li>Browser and device type</li>
                      <li>Referral source (how you found us)</li>
                    </ul>
                    <p className="mt-2 text-sm text-content-2">
                      Note: We use Google Analytics 4 with IP anonymization enabled and no user tracking across sites.
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-content mb-4">What We DON'T Do</h2>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>We don't use advertising or marketing cookies</li>
                  <li>We don't track you across other websites</li>
                  <li>We don't sell or share your data with third parties</li>
                  <li>We don't use cookies for personalized advertising</li>
                  <li>We don't store personal information in cookies</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-content mb-4">Your Cookie Choices</h2>
                <p className="mb-3">You have full control over cookies:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li><strong>Browser Settings:</strong> You can disable cookies entirely in your browser settings</li>
                </ul>
                <p className="mt-3 text-sm text-content-2">
                  Note: Disabling cookies entirely may impact website functionality.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-content mb-4">How to Manage Cookies</h2>
                <p className="mb-3">You can manage cookies through:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Your browser settings (usually found under Privacy or Security)</li>
                  <li>Google Analytics Opt-out Browser Add-on</li>
                  <li>Do Not Track browser setting (we honor this)</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-content mb-4">Updates to This Policy</h2>
                <p>
                  We may update this policy to reflect changes in our practices or legal requirements. 
                  Any changes will be posted on this page with an updated revision date.
                </p>
              </div>

              <div className="mt-8 pt-6 border-t border-line">
                <p className="text-sm text-content-2">
                  Last updated: January 2025
                </p>
                <p className="text-sm text-content-2 mt-2">
                  Questions about our cookie policy? Contact us at privacy@databurst.dev
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Simple Footer */}
      <footer className="bg-surface-2 text-content py-8 mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-content-2">
            © 2017-2026 Databurst Technologies LLC. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default CookiePolicy;